@import "~/styles/variables";

.Circle {
  @include circle($space-l);
  @include font-color("light");
  @include font-size("xs");
  @include font-weight("semibold");
  background: $color-grey;
}

.Meta {
  line-height: $font-size-m;
}
